import React from 'react';
import classNames from 'classnames/bind';
import properties from '../../../modules/ajio-util/properties';
import styles from './index.pcss';
import { connect } from 'react-redux';
import { getRatingParityMsiteFlag, getRatingsColorConfig } from '../../../refresh/selectors/featureFlagsSelector';
import { isMobile } from '../../utils/deviceTypeUtils';

interface AggregatedRatingTag {
  ratingValue: number;
  totalRatingCount: string;
  backGroundColour: string;
  customClass?: string;
  size: string;
  displayRatingCount?: boolean;
  fleek?: boolean;
  isFleek?: boolean;
  isFromPDP?: boolean;
  code?: string;
  ratingParityMsite?: boolean;
  luxe?: boolean;
}
const cx = classNames.bind(styles);
const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;

const mapStateToProps = (
  state: import('../../types/rootState').RootState
): import('../../types/product-page-types').ProductPageProps => ({
  ratingsColor: getRatingsColorConfig(state?.flags),
  ratingParityMsite: getRatingParityMsiteFlag(state)
});

const AggregatedRatingTag = (props: AggregatedRatingTag): JSX.Element => {
  const {
    ratingValue,
    totalRatingCount,
    backGroundColour,
    customClass = '',
    size = 'sm',
    displayRatingCount = true,
    isFleek = false,
    fleek = false,
    ratingsColor = {},
    isFromPDP = false,
    code = '',
    ratingParityMsite = false,
    luxe = false
  } = props;

  const {
    thresholdValue = 3,
    ratingBelowThresholdColor = '',
    ratingAboveThresholdColor = ''
  } = ratingsColor;

  const isMobileDevice = isMobile();

  const getStarIcon = (value: number) => {
    if (value >= 1) return `${imageBaseRef}black-star-one.svg`;
    if (value >= 0.6) return `${imageBaseRef}black-star-point-six.svg`;
    if (value >= 0.5) return `${imageBaseRef}black-star-point-five.svg`;
    if (value > 0) return `${imageBaseRef}black-star-point-four.svg`;
    return `${imageBaseRef}black-star-zero.svg`;
  };

  const getStar = () => {
    const stars = Array.from({ length: 5 }, (_, i) => {
      const value = Math.min(Math.max(ratingValue - i, 0), 1);
      const icon = getStarIcon(value);

      return (
        <img
          key={i}
          src={icon}
          alt={`star-${i + 1}`}
        />
      );
    });
    return stars;
  }

  if(!luxe && ratingParityMsite && isMobileDevice){
    return(
      <div
        className={` ${cx('black-star-rating-container')}`}
        // style={{ backgroundColor: RatingCountBgColor }}
        aria-label={`${totalRatingCount} stars rating out of 5 stars`}
      >
        <span  aria-hidden="true">
          {getStar()}
        </span>
      </div>
    )
  }

  return (
    <div
      className={cx('tagContainer', `${backGroundColour}`, `${customClass}`, `${size}`)}
      style={{
        backgroundColor:
          ratingValue < thresholdValue ? ratingBelowThresholdColor : ratingAboveThresholdColor
      }}
      tabIndex={0}
      aria-label={`${ratingValue} star rating ${displayRatingCount && totalRatingCount ? `and ${totalRatingCount} reviews` : ''}`}
      {...(code ? { id: `rating-value-container-${code}`, 'aria-hidden': 'true' } : {})}
    >
      <div className={cx('ratingValueContainer', isFromPDP ? 'widget_coverage' : '')} >
        <p className={cx('ratingValue', { 'fleek-rating-value': fleek })} aria-label={ratingValue}>
          {ratingValue}
        </p>
        <div className={cx('starIconContainer')}>
          <img
            alt={fleek || isFleek ? 'Star selected' : 'Star icon'}
            className={cx('imageIcon')}
            src={`${imageBaseRef}${
              fleek || isFleek ? 'fleek-rating-black-star.svg' : 'white-star-display.svg'
            }`}
          />
        </div>
      </div>
      {displayRatingCount && (
        <p className={cx({ 'fleek-rating-count': fleek })} aria-label={`| ${totalRatingCount}`} aria-hidden="true">
          {'|   '}
          {totalRatingCount}
        </p>
      )}
    </div>
  );
};

const connector = connect(mapStateToProps, {});
export default connector(AggregatedRatingTag);
